import { Component, inject, signal } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { AdminAuthService } from '../auth/admin-auth.service';

interface NavItem {
  label: string;
  icon: string;
  routerLink?: string;
  disabled?: boolean;
}

@Component({
  selector: 'app-main-layout',
  imports: [RouterModule, ButtonModule],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss',
})
export class MainLayoutComponent {
  private readonly auth = inject(AdminAuthService);
  private readonly router = inject(Router);

  protected readonly navItems: NavItem[] = [
    {
      label: 'Care Homes',
      icon: 'pi pi-home',
      routerLink: '/care-homes',
    },
    {
      label: 'Cron Jobs',
      icon: 'pi pi-clock',
      routerLink: '/cron-jobs',
    },
    {
      label: 'Settings',
      icon: 'pi pi-cog',
      disabled: true,
    },
  ];

  protected readonly currentUser = signal(
    this.auth.currentUser?.email ?? 'Admin'
  );

  protected async logout(): Promise<void> {
    await this.auth.logout();
    this.router.navigate(['/login']);
  }
}
